import { useParams } from "wouter";
import { useState, useEffect } from "react";
import { Project } from "../lib/store";
import { useAppStore } from "../lib/store";

export function useAdminProject() {
  const params = useParams<{ projectId?: string }>();
  const { selectedProject, setSelectedProject } = useAppStore();
  const [loading, setLoading] = useState(false);

  // Extract project ID from URL
  const projectId = params?.projectId;

  // Sync URL project ID with global store
  useEffect(() => {
    if (projectId && (!selectedProject || selectedProject.id !== projectId)) {
      // Create a minimal project object from URL parameter
      // The full project details will be loaded by the Header component
      const urlProject: Project = {
        id: projectId,
        name: 'Loading Project...', // Will be updated when projects are loaded
        hubId: '', // Will be updated when projects are loaded
        status: 'active'
      };
      
      // Check if we have project data in localStorage (from MyHomePage)
      const storedProject = localStorage.getItem('selectedProject');
      if (storedProject) {
        try {
          const parsedProject = JSON.parse(storedProject);
          if (parsedProject.id === projectId) {
            urlProject.name = parsedProject.name;
            urlProject.hubId = parsedProject.hubId;
            urlProject.hubName = parsedProject.hubName;
          }
        } catch (e) {
          console.warn('Failed to parse stored project data');
        }
      }
      
      setSelectedProject(urlProject);
      setLoading(true);
    }
  }, [projectId, selectedProject, setSelectedProject]);

  // Clear loading state when project is fully loaded
  useEffect(() => {
    if (selectedProject && !selectedProject.name.includes('Loading')) {
      setLoading(false);
    }
  }, [selectedProject]);

  return {
    projectId,
    selectedProject,
    loading,
    setSelectedProject
  };
}
